import { createSlice } from "@reduxjs/toolkit";

const initalState = {
  selectedFilterTheme: [],
  selectedStatus:[],
  selectedFilterPopups: [],
  selectedSharedUid: null,
  selectedSite: null,
  pageGroupData: [],
  siteOptions: [],
  selectedPageGroupShareuid: null,
  page: 0,
  selectedPageGroup: null,
};

const pageGroupSlice = createSlice({
  name: "pageGroup",
  initialState: initalState,
  reducers: {
    setSelectedFilterTheme: (state, action) => {
      state.selectedFilterTheme = action.payload;
    },
    setSelectedStatus: (state, action) => {
      state.selectedStatus = action.payload;
    },
    setSelectedFilterPopups: (state, action) => {
      state.selectedFilterPopups = action.payload;
    },
    setSelectedSite: (state, action) => {
      state.selectedSite = action.payload;
    },
    setSelectedSharedUid: (state, action) => {
      state.selectedSharedUid = action.payload;
    },
    setPageGroupData: (state, action) => {
      state.pageGroupData = action.payload;
    },
    setSiteOptions: (state, action) => {
      state.siteOptions = action.payload;
    },
    setSelectedPageGroupShareuid: (state, action) => {
      state.selectedPageGroupShareuid = action.payload;
    },
    setPage: (state, action) => {
      state.page = action.payload;
    },
    setSelectedPageGroup: (state, action) => {
      state.selectedPageGroup = action.payload;
    },
  },
});

export const {
  setSelectedFilterTheme,
  setSelectedStatus,
  setSelectedFilterPopups,
  setSelectedSharedUid,
  setSelectedSite,
  setPageGroupData,
  setSiteOptions,
  setSelectedPageGroupShareuid,
  setPage,
  setSelectedPageGroup,
} = pageGroupSlice.actions;
export default pageGroupSlice.reducer;
